
function isPrime(num) {
    if (num < 2) return false;
    for (let i = 2; i <= Math.sqrt(num); i++) {
        if (num % i === 0) return false;
    }
    return true;
}

function getPrimesUpTo(max) {
    const primes = [];
    for (let i = 2; i <= max; i++) {
        if (isPrime(i)) primes.push(i);
    }
    return primes;
}

export function findBestRnBkGrids(targetMeshSizeKm) {
    const maxN = 30;
    const maxK = 20;
    const maxAllowedError = targetMeshSizeKm * 0.1; // 10% tolerance
    const primes = getPrimesUpTo(maxN);
    const matches = [];

    for (const n of primes) {
        for (let k = 1; k <= maxK; k++) {
            const R_Earth = 6371; // Earth radius in km
            const meshSize = (R_Earth * Math.sqrt(Math.PI / 5)) / (n * Math.pow(2, k));
            const error = Math.abs(meshSize - targetMeshSizeKm);

            if (error <= maxAllowedError && meshSize - error >= 0.5) {
                matches.push({ n, k, meshSize, error });
            }
        }
    }

    // Sort by error (ascending)
    matches.sort((a, b) => a.error - b.error);

    // Return top 3 results
    return matches.slice(0, 3);
}
